
jQuery('body').on('click', '.addtocart_btn', function(){
  var productid = jQuery(this).attr('data-productid');
  if(jQuery("input[name="+ productid +"]").is(':checked')){
    var varid = jQuery("input[name="+ productid +"]:checked").val();
  }
  console.log(productid+'____'+varid);
  let formData = {
    'items': [{
      'id': varid,
      'quantity': 1
    }]
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    cache:false,
    data:formData,
    dataType: "json",
    success: function (data) {
      console.log("success");
      //document.querySelector('cart-notification').renderContents(data);
      //getSectionsToRender();
      window.location.replace("/cart");
    },
    error: function (xhr, ajaxOptions, thrownError) {
      console.log("error");
      console.log(xhr.status);
      console.log(thrownError);
    }
  });
})

$(document).on('click', '.product-form__buttons button[type="submit"]', function(e){
    e.preventDefault();
    if( $('input[name="Size"]:checked').val() == 'Pick 5' ){
       window.location.href = '/pages/5-pack-products-page';
    }else{
       $(this).parents('form').submit();
    }
});


jQuery('body').on('click', '.buynow_btn', function(){
  var productid = jQuery(this).attr('data-productid');
  if(jQuery("input[name="+ productid +"]").is(':checked')){
    var varid = jQuery("input[name="+ productid +"]:checked").val();
  }
  console.log(productid+'____'+varid);
  let formData = {
    'items': [{
      'id': varid,
      'quantity': 1
    }]
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    cache:false,
    data:formData,
    dataType: "json",
    success: function (data) {
      console.log("success");
      //document.querySelector('cart-notification').renderContents(data);
      //getSectionsToRender();
      window.location.replace("/checkout");
    },
    error: function (xhr, ajaxOptions, thrownError) {
      console.log("error");
      console.log(xhr.status);
      console.log(thrownError);
    }
  });
})
